module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/rooms/mindful/mindful-02slide_02.png";